import React from 'react';
import {
	TextField,
	FormHelperText,
	MenuItem,
	Checkbox,
	ListItemText,
	ListSubheader,
	FormControlLabel,
	Stack,
	Box,
	ListItem,
	IconButton,
	ListItemIcon,
	ListItemButton,
	Collapse,
	Chip,
	Avatar,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { List } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

function RenderSelectGroupMultipleCheckbox({ input, meta: { invalid, touched, error, active }, ...custom }) {
	let value = input.value.length === 0 ? [] : input.value;
	const translate = useSelector((state) => getTranslate(state.localize));

	const [uncollapsed, setUncollapsed] = React.useState([]);

	const renderChildOptions = (options) => {
		const items = [];

		return (
			<List>
				{custom.inputdata.select_all && (
					<ListItem key={'all'} disablePadding value={'all'}>
						<ListItemButton
							value={'all'}
							role={undefined}
							onClick={() => {
								let new_value = [...value];
								let checked =
									value.length == options.length &&
									!value.some(
										(parent) =>
											value[Object.keys(parent)[0]].length ==
											options.find((item) => item.value == Object.keys(parent)[0]).length
									);

								if (checked) {
									new_value = [];
								} else {
									new_value = options.map((item) => ({ [item.value]: item.options.map((option) => option.value) }));
								}

								console.log('CHECKED', new_value);
								input.onChange(new_value);
							}}
							dense
						>
							<ListItemIcon>
								<Checkbox
									edge="start"
									checked={
										value.length == options.length &&
										!value.some(
											(parent) =>
												value[Object.keys(parent)[0]].length ==
												options.find((item) => item.value == Object.keys(parent)[0]).length
										)
									}
									tabIndex={-1}
									disableRipple
									inputProps={{ 'aria-labelledby': 'aa' }}
								/>
							</ListItemIcon>
							<ListItemText id={'all'} primary={'-- All --'} />
						</ListItemButton>
					</ListItem>
				)}
				{options.map((group, key) => (
					<React.Fragment key={key}>
						<ListItem
							key={value}
							secondaryAction={
								<IconButton
									edge="end"
									aria-label="comments"
									onClick={() =>
										uncollapsed.includes(group.value)
											? setUncollapsed(uncollapsed.filter((value) => value != group.value))
											: setUncollapsed((prev) => [...prev, group.value])
									}
								>
									{uncollapsed.includes(group.value) ? <ExpandLess /> : <ExpandMore />}
								</IconButton>
							}
							disablePadding
							value={group.value}
						>
							<ListItemButton
								value={group.value}
								role={undefined}
								onClick={() => {
									let new_value = [...value];
									let checked = value.some((parent) => Object.keys(parent).includes(group.value));

									if (checked) {
										new_value = value.filter((parent) => !Object.keys(parent).includes(group.value));
									} else {
										new_value = [{ [group.value]: 'all' }, ...value];
									}

									console.log('CHECKED', new_value);
									input.onChange(new_value);
								}}
								dense
							>
								<ListItemIcon>
									<Checkbox
										edge="start"
										checked={value.some((parent) => Object.keys(parent).includes(group.value))}
										indeterminate={value.some(
											(parent) =>
												Object.keys(parent).includes(group.value) &&
												parent[group.value] != 'all' &&
												parent[group.value].length < group.options.length
										)}
										tabIndex={-1}
										disableRipple
										inputProps={{ 'aria-labelledby': key }}
									/>
								</ListItemIcon>
								<ListItemText id={key} primary={group.label} />
							</ListItemButton>
						</ListItem>
						<Collapse in={uncollapsed.includes(group.value)} timeout="auto" unmountOnExit>
							<List component="div" disablePadding>
								{group.options.map((child) => (
									<ListItemButton
										sx={{ pl: 4 }}
										dense
										onClick={() => {
											// input.onChange(['1']);
											let new_value = [...value];
											console.log(new_value);

											let has_parent = new_value.some((parent) => Object.keys(parent).includes(group.value));
											let fake_checked = value.some(
												(parent) => Object.keys(parent).includes(group.value) && parent[group.value] === 'all'
											);

											let checked = value.some(
												(parent) =>
													Object.keys(parent).includes(group.value) &&
													Array.isArray(parent[group.value]) &&
													parent[group.value].includes(child.value)
											);

											if (!has_parent) {
												new_value = [{ [group.value]: [child.value] }, ...new_value];
											} else if (!checked && !fake_checked) {
												// new_value[group.value] = [
												// 	...[child.value],
												// 	...(new_value[group.value] && new_value[group.value].length > 0 ? new_value[group.value] : []),
												// ];
												new_value = new_value.map((parent) => {
													if (Object.keys(parent).includes(group.value)) {
														console.log('AQUI');
														return { [group.value]: [...(parent[group.value] || []), child.value] };
													}
													return { [parent.value]: [...child.value] };
												});
											} else if (fake_checked) {
												new_value = new_value.map((parent) => {
													if (Object.keys(parent).includes(group.value)) {
														return {
															[group.value]: group.options
																.map((option) => option.value)
																.filter((value) => value !== child.value),
														};
													}
													return parent;
												});
											} else {
												new_value = new_value.map((parent) => {
													if (Object.keys(parent).includes(group.value)) {
														return {
															[group.value]: parent[group.value].filter((value) => value !== child.value),
														};
													}
													return parent;
												});
											}

											console.log('CHECKED', new_value);
											input.onChange(new_value);
										}}
									>
										<ListItemIcon>
											<Checkbox
												edge="start"
												checked={value.some(
													(parent) =>
														Object.keys(parent).includes(group.value) &&
														(parent[group.value] === 'all' || parent[group.value].includes(child.value))
												)}
												tabIndex={-1}
												disableRipple
												inputProps={{ 'aria-labelledby': key }}
											/>
										</ListItemIcon>
										<ListItemText primary={child.label} />
									</ListItemButton>
								))}
							</List>
						</Collapse>
					</React.Fragment>
				))}
			</List>
		);
		// return (
		// 	<Stack direction={'column'} sx={{ marginLeft: 2 + ' !important' }}>
		// 		{options.map((group, key) => (
		// 			<React.Fragment>
		// 				<FormControlLabel
		// 					sx={{ marginLeft: 0 }}
		// 					label={group.label}
		// 					control={
		// 						<Checkbox
		// 							checked={value.includes(group.value)}
		// 							indeterminate={value.includes(group.value)}
		// 							// onChange={handleChange1}
		// 						/>
		// 					}
		// 				/>
		// 				<Box sx={{ display: 'flex', flexDirection: 'column', ml: 3 }}>
		// 					{group.options.map((child) => (
		// 						<FormControlLabel label={child.label} control={<Checkbox checked={value.includes(child.value)} />} />
		// 					))}
		// 				</Box>
		// 			</React.Fragment>
		// 		))}
		// 	</Stack>
		// );
	};

	return (
		<div>
			<TextField
				{...input}
				value={value}
				id={custom.inputdata.id}
				name={custom.inputdata.name}
				label={custom.inputdata.label}
				placeholder={custom.inputdata.placeholder}
				fullWidth
				variant="outlined"
				disabled={custom.inputdata.readonly}
				error={touched && invalid && !active}
				helperText={touched && !active && error}
				SelectProps={{
					onChange: (event, child) => {
						// console.log(event, child);
					},
					multiple: true,
					renderValue: (selected) => {
						let display_value = selected.map((value, key) => {
							let option = custom.inputdata.options.find((item) => item.value == Object.keys(value)[0]);
							return option ? (
								<Chip key={key} avatar={<Avatar>{value[Object.keys(value)[0]].length}</Avatar>} label={option.label} sx={{ ml: 1 }} />
							) : (
								''
							);
						});
						return display_value;
					},
				}}
				type={custom.inputdata.type}
				size={custom.inputdata.size ? custom.inputdata.size : null}
				{...custom}
				inputProps={{
					step: custom.inputdata.props ? custom.inputdata.props.step : null,
					min: custom.inputdata.props ? custom.inputdata.props.min : null,
					className: custom.inputdata.disableNumberArrows ? 'number-input' : null,
				}}
			>
				<Stack spacing={1} direction={'column'}>
					{renderChildOptions(custom.inputdata.options)}
				</Stack>
			</TextField>
			<FormHelperText id="my-helper-text"> {custom.inputdata.helperText}</FormHelperText>
		</div>
		// required={(custom.inputdata.validate && custom.inputdata.validate.required) ? true : false}
	);
}

export default RenderSelectGroupMultipleCheckbox;
